import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = { ref: "sectionToScroll" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderComponent = _resolveComponent("HeaderComponent")!
  const _component_BannerComponent = _resolveComponent("BannerComponent")!
  const _component_SectionComponent = _resolveComponent("SectionComponent")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HeaderComponent, { screenName: "" }),
    _createVNode(_component_BannerComponent, {
      onScrollToSection: _cache[0] || (_cache[0] = ($event: any) => (_ctx.scrollToSection()))
    }),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sectionsData, (section, index) => {
        return (_openBlock(), _createBlock(_component_SectionComponent, {
          key: index,
          "image-url": require(`@/assets/home/${section.imageName}`),
          heading: section.heading,
          subheading: section.subheading,
          "is-flip": section.flip,
          "is-opaque": section.opaque,
          content: section.content,
          isBlack: section.isBlack,
          "data-aos": "fade-up"
        }, null, 8, ["image-url", "heading", "subheading", "is-flip", "is-opaque", "content", "isBlack"]))
      }), 128))
    ], 512),
    _createVNode(_component_FooterComponent)
  ]))
}